import React, { useState } from 'react';
import { Field, Form, Formik } from 'formik';
import { object, string } from 'yup';
import { faCalendarDay } from '@fortawesome/free-solid-svg-icons/faCalendarDay';

import Button, { BUTTON_TYPES } from 'buyside/components/presentation/Button/button';
// import useMakeStripeCheckout from 'buyside/util/hooks/useMakeStripeCheckout';

import {
  useEmailSearchLazyQuery,
  useEventRegistrationMutation,
  useRegistrantSearchLazyQuery
} from 'interfaces/graphql-typings';
// import { STRIPE_PLANS } from 'interfaces/payment/plans';

import styles from './publicRegistrationStyles.scss';

const PublicRegistrationForm: React.FC = () => {
  const [success, setSuccess] = useState(false);
  // const { onSubmit: eventCheckoutOnSubmit, loading: eventCheckoutLoading } = useMakeStripeCheckout(
  //   STRIPE_PLANS.event
  // );
  const [
    registerForEvent,
    { loading: registerForEventLoading, error: registerForEventError }
  ] = useEventRegistrationMutation();

  const [
    checkIfRegistered,
    { loading: registrantLoading, error: registrantError }
  ] = useRegistrantSearchLazyQuery();

  const [checkIfMember, { loading: memberLoading, error: memberError }] = useEmailSearchLazyQuery();

  // const onSubmit = (values: FormikValues): void => eventCheckoutOnSubmit(values.email);

  const validateEmail = async (email: string): Promise<string | void> => {
    const [registeredRes, memberRes] = await Promise.all([
      checkIfRegistered({ variables: { email } }),
      checkIfMember({ variables: { email, userOnly: true } })
    ]);

    if (registeredRes.data?.registrantSearch) return 'Your request has been received';
    if (memberRes.data?.emailSearch) return 'Please log in to your SumZero account';
  };

  if (registerForEventError) throw registrantError;
  if (registrantError) throw registrantError;
  if (memberError) throw memberError;

  return (
    <Formik<{ email: string; firstName: string; lastName: string; firmName: string }>
      initialValues={{ email: '', firstName: '', lastName: '', firmName: '' }}
      onSubmit={values =>
        registerForEvent({ variables: values }).then(({ data }) => {
          setSuccess(Boolean(data?.createEventRegistration?.registered));
        })
      }
      validateOnBlur={false}
      validateOnChange={false}
      validationSchema={object().shape({
        email: string()
          .email('Please enter a valid email')
          .required('This field is required'),
        firstName: string().required('This field is required'),
        lastName: string().required('This field is required'),
        firmName: string().required('This field is required')
      })}
    >
      {({ isSubmitting, errors, values }): React.ReactElement => (
        <Form
          className={styles.registrationForm}
          placeholder={undefined}
          onPointerEnterCapture={undefined}
          onPointerLeaveCapture={undefined}
        >
          <div className={styles.formFieldGroup}>
            <Field name="email" placeholder="Email" validate={validateEmail} />
            <Field name="firstName" placeholder="First Name" />
            <Field name="lastName" placeholder="Last Name" />
            <Field name="firmName" placeholder="Firm Name" />
          </div>
          <Button
            disabled={
              !Object.keys(values).every(key => Boolean(values[key as keyof typeof values]))
            }
            faIcon={faCalendarDay}
            // isLoading={registrantLoading || memberLoading || eventCheckoutLoading || isSubmitting}
            isLoading={
              !success &&
              (registrantLoading || memberLoading || registerForEventLoading || isSubmitting)
            }
            text="Join the Waitlist"
            type={BUTTON_TYPES.PRIMARY}
          />
          {errors.email ? <div className={styles.registrationFormError}>{errors.email}</div> : null}
          {success ? (
            <div className={styles.registrationFormError}>
              Thank you. We have received your request.
            </div>
          ) : null}
        </Form>
      )}
    </Formik>
  );
};

export default PublicRegistrationForm;
